import React from "react";
import StaticPage from "../components/StaticPage";

export default function Crowdfunding() {
    return (
        <StaticPage
            kicker="Crowdfunding"
            title="Soon: fractional rights for the crowd."
            lede="A pilot programme letting verified investors co-own future-release film copyright through small, fractional stakes — pooled, escrowed and legally assigned."
            blocks={[
                { eyebrow: "How it works", title: "Fractional rights pools",
                  body: "A film lists with a rights target (e.g. $500K). Verified investors subscribe with fractional tickets of $500–$10,000. When fully funded, copyright is jointly held via an SPV." },
                { eyebrow: "Protections", title: "Escrow + refund",
                  body: "All funds sit in escrow until the raise completes. If the raise fails, every cent is refunded; if it completes, Transfer Record is issued to the SPV." },
                { eyebrow: "Upside", title: "Share in licensing",
                  body: "As the film is licensed to streamers, theatrical distributors or remakes, revenues distribute pro-rata to fractional owners — quarterly." },
                { eyebrow: "Coming soon", title: "Request access",
                  body: "We're onboarding accredited backers for the pilot cohort later this quarter. If you're interested, get in touch." },
            ]}
            cta={{ label: "Join the pilot waitlist", href: "/contact" }}
        />
    );
}
